const getters = {
  token: (state) => state.permission.token,
  getPid: (state) => state.business.pid,
  unique: (state) => state.unique.unique,
  policy_no: (state) => state.policy_no.policy_no
}
export default getters